import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";
const quietMode = import.meta.env.VITE_ENV === "development";
const quietLogger = {
  debug() {},
  info() {},
  warn() {},
  error() {},
};

Bugsnag.start({
  appVersion: import.meta.env.VITE_APP_VERSION,
  apiKey: import.meta.env.VITE_BUGSNAG_KEY,
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ["staging", "production"],
  releaseStage: import.meta.env.VITE_ENV,
  generateAnonymousId: false,
  collectUserIp: false,
  ...(quietMode ? { logger: quietLogger } : {}),
});

export default Bugsnag;

export const ErrorBoundary =
  Bugsnag.getPlugin("react")?.createErrorBoundary(React);
